export const app_slice_name = 'WEBAPP';

export const app_thunks = {
  APP_GET_CONFIG: `${app_slice_name}/getAppConfig`,
};
